import React from "react";

const Hero = () => {
  return (
    <section
  id="home"
  className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat mt-[4rem]"
  style={{
    backgroundImage:
      "linear-gradient(rgba(198, 186, 186, 0.5), rgba(182, 181, 181, 0.72)), url('/assets/homepage.jpeg')",
  }}
>
  <div className="container mx-auto px-6 text-center relative z-10">
    <h1 className="text-5xl md:text-6xl font-bold text-black mb-6">
      Building Dreams into Reality
    </h1>
    <p className="text-3xl text-black/90 mb-10 max-w-2xl mx-auto">
      Transforming residential spaces with exceptional construction and
      interior design services
    </p>
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <a
        href="#projects"
        className="bg-black text-white px-8 py-4 rounded-lg border border-black text-xl transition-all transform hover:scale-105"
      >
        View Our Work
      </a>
      <a
        href="#contact"
        className="bg-black text-white border border-black px-8 py-4 rounded-lg text-xl transition-all transform hover:scale-105"
      >
        Contact Us
      </a>
    </div>
  </div>
</section>

  );
};

export default Hero;
